export default {
    overview: {
        actions: {
            view: true,
            exceedDailyAvg: true
        },
        numericalOrder: 1,
        description: 'Trang chủ',
        key: 'overview'
    },
    ticket: {
        actions: {
            view: true,
            create: true,
            edit: true,
            delete: true,
        },
        description: 'Sự cố',
        numericalOrder: 2,
        key: "ticket",
    },   
    stationPeriodic: {
        actions: {
            view: true,
            create: true,
        },
        description: 'Quan trắc định kỳ',
        numericalOrder: 3,
        key: "stationPeriodic",
    },
    connection: {
        actions: {
            view: true,
            create: true,
            connect: true,
        },
        description: 'Kết nối',
        numericalOrder: 4,
        key: "connection",
    },
    report: {
        actions: {
            view: true,
        },
        description: 'Báo cáo',
        numericalOrder: 5,
        key: "report",
    }
}


// WEBPACK FOOTER //
// ./src/constants/menuMobile.js